import axios from 'axios'
import {
    AuthenticationParams,
    AuthenticationRequest,
    GlobalExternalAuthenticationResponse,
    PasswordChangerRequestDto, RecoveryPasswordChangerRequestDto, UserTokenResponse
} from '@/api/services/auth/auth.dto'

class AuthService {
    async changePassword(passwordChangerRequestDto: PasswordChangerRequestDto): Promise<void> {
        const response = await axios.put<void>('/auth/changePassword', passwordChangerRequestDto)
        return response.data
    }

    async changePasswordAfterFirstLogin(passwordChangerRequestDto: RecoveryPasswordChangerRequestDto): Promise<void> {
        const response = await axios.put<void>('/auth/changePasswordAfterFirstLogin', { ...passwordChangerRequestDto })
        return response.data
    }

    async isAuthenticated(): Promise<void> {
        const response = await axios.get<void>('/auth/isAuthenticated')
        return response.data
    }

    async isGlobalExternalAuthentication(locale: string): Promise<GlobalExternalAuthenticationResponse> {
        const response = await axios.get<GlobalExternalAuthenticationResponse>(`/auth/isGlobalExternalAuthentication/${locale}`)
        return response.data
    }

    async login(authenticationRequest: AuthenticationRequest, params?: AuthenticationParams): Promise<UserTokenResponse> {
        const response = await axios.post<UserTokenResponse>('/auth/login', { ...authenticationRequest }, { params })
        return response.data
    }

    async logout(): Promise<void> {
        const response = await axios.post<void>('/auth/logout')
        return response.data
    }

    async recoveryChangePassword(newPasswordDto: RecoveryPasswordChangerRequestDto, params?: AuthenticationParams): Promise<UserTokenResponse> {
        const response = await axios.put<UserTokenResponse>(`/auth/recoveryChangePassword`, { ...newPasswordDto }, { params })
        return response.data
    }

    async recoveryPassword(username: string, params?: AuthenticationParams): Promise<void> {
        const response = await axios.post<void>('/auth/recoveryPassword', undefined, {
            params: {
                username,
                ...params
            }
        })
        return response.data
    }

    async refresh(): Promise<UserTokenResponse> {
        const response = await axios.post<UserTokenResponse>('/auth/refresh')
        return response.data
    }
}

export const authService = new AuthService()
